import { render, staticRenderFns } from "./EditBudgetType.vue?vue&type=template&id=bc93161c&scoped=true"
import script from "./EditBudgetType.vue?vue&type=script&lang=js"
export * from "./EditBudgetType.vue?vue&type=script&lang=js"
import style0 from "./EditBudgetType.vue?vue&type=style&index=0&id=bc93161c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc93161c",
  null
  
)

export default component.exports